export default function($) {
  let featuredProducts = $('.js-featured-products-slider');
  let featuredProductsTitle = featuredProducts.data('title');

  let lastProducts = $('.js-last-products-slider');
  let lastProductsTitle = lastProducts.data('title');

  let reinsurance = $('.js-reinsurance-slider');
  let mobileSwiper = $('.js-mobile-slider');
  let initMobileSwiper = false;

  const homeSwiper = new Swiper('.js-home-slider', {
    loop: true,
    slidesPerView: 1,
    speed: 750,
    autoplay: {
      delay: 10000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        navigation: {
          enabled: true,
        }
      }
    },
    a11y: {
      containerRole: 'region',
      containerMessage: "Carrousel d\'actualités"
    },
  });

  const featuredProductsParams = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".featured-products-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      460: {
        slidesPerView: 1.5,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
    on: {
      destroy: function() {
        $('.featured-products-swiper-pagination').hide();
      },
      init: function() {
        $('.featured-products-swiper-pagination').show();
      },
    },
    a11y: {
      containerRole: 'region',
      containerMessage: "Carrousel : " + featuredProductsTitle
    }
  };

  const lastProductsParams = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".last-products-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      460: {
        slidesPerView: 1.5,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
    on: {
      destroy: function() {
        $('.last-products-swiper-pagination').hide();
      },
      init: function() {
        $('.last-products-swiper-pagination').show();
      },
    },
    a11y: {
      containerRole: 'region',
      containerMessage: "Carrousel : " + lastProductsTitle
    },
  };

  const reinsuranceParams = {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".reinsurance-swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: true,
      nextEl: ".reinsurance-swiper-button-next",
      prevEl: ".reinsurance-swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
    on: {
      destroy: function() {
        $('.reinsurance-swiper-pagination').hide();
        $('.reinsurance-swiper-button-next').hide();
        $('.reinsurance-swiper-button-prev').hide();
      },
      init: function() {
        $('.reinsurance-swiper-pagination').show();
        $('.reinsurance-swiper-button-next').show();
        $('.reinsurance-swiper-button-prev').show();
      },
    },
    a11y: {
      containerRole: 'region',
      containerMessage: 'Réassurance client'
    }
  };

  const mobileSwiperParams = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".mobile-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      460: {
        slidesPerView: 1.8,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
    a11y: {
      containerRole: 'region'
    }
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( $('.js-featured-products-slider').length > 0 && !featuredProducts.initialized ) {
        featuredProducts = new Swiper('.js-featured-products-slider', featuredProductsParams);
      };
      if( $('.js-last-products-slider').length > 0 && !lastProducts.initialized ) {
        lastProducts = new Swiper('.js-last-products-slider', lastProductsParams);
      };
      if( $('.js-reinsurance-slider').length > 0 && !reinsurance.initialized ) {
        reinsurance = new Swiper('.js-reinsurance-slider', reinsuranceParams);
      };

      if( !initMobileSwiper ) {
        initMobileSwiper = true;

        $('.js-mobile-slider').each(function(index) {
          let sliderDiv = $(this)[0]
          mobileSwiper = new Swiper(sliderDiv, mobileSwiperParams);
        })
      }
    }

    else {
      if( $('.js-featured-products-slider').length > 0 && featuredProducts.initialized ) {
        featuredProducts.destroy(false,true);
        $('.js-featured-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.featured-products-swiper-pagination').hide();
      };

      if( $('.js-last-products-slider').length > 0 && lastProducts.initialized ) {
        lastProducts.destroy(false,true);
        $('.js-last-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.last-products-swiper-pagination').hide();
      };

      if( $('.js-reinsurance-slider').length > 0 && reinsurance.initialized ) {
        reinsurance.destroy(false,true);
        $('.js-reinsurance-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.reinsurance-swiper-pagination').hide();
        $('.reinsurance-swiper-button-next').hide();
        $('.reinsurance-swiper-button-prev').hide();
      };

      if( $('.js-mobile-slider').length) {
        $('.js-mobile-slider').each( function() {
          let sliderDiv = $(this)[0]
          if (sliderDiv.swiper) {
            sliderDiv.swiper.destroy(false,true)
          }
        })

        initMobileSwiper = false
      }
    }
  }
}
